export default "__VITE_PUBLIC_ASSET__c929eac4__"